import { keepPreviousData, useQuery } from "@tanstack/react-query";
import Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
import { TABLE_LAYOUT_DEFAULT_FILTERS_KEY_SPLITTER } from "components/common/EntityDataTable/Constants";
const INITIAL_DATA = {};
const filtersFromJson = (filters) => filters.reduce((queryFilters, jsonFilter) => {
  const [key, stringValues] = jsonFilter.split(TABLE_LAYOUT_DEFAULT_FILTERS_KEY_SPLITTER);
  if (queryFilters.get(key)) {
    return queryFilters.set(key, queryFilters[key].push(stringValues));
  }
  return queryFilters.set(key, [stringValues]);
}, Immutable.OrderedMap({}));
const preferencesFromJSON = (preferences) => {
  const { attributes, sort, per_page, slicing, custom_preferences, order, filters } = preferences;
  const hasSlicingPreference = Object.prototype.hasOwnProperty.call(preferences, "slicing");
  const defaultFilters = filters ? filtersFromJson(filters) : void 0;
  const result = {
    attributes,
    sort: sort ? { attributeId: sort.field, direction: sort.order } : void 0,
    perPage: per_page,
    customPreferences: custom_preferences,
    order,
    defaultFilters
  };
  if (hasSlicingPreference) {
    result.slicing = slicing ? {
      sliceColumn: slicing.slice_column,
      sortBy: slicing.sort_by,
      order: slicing.order,
      ...slicing.read_only !== void 0 ? { readOnly: slicing.read_only } : {}
    } : null;
  }
  return result;
};
const preferencesUrl = (entityId, layoutVariant) => {
  const params = layoutVariant ? `?layout_variant=${encodeURIComponent(layoutVariant)}` : "";
  return qualifyUrl(`/entitylists/preferences/${entityId}${params}`);
};
const fetchUserLayoutPreferences = (entityId, layoutVariant) => fetch("GET", preferencesUrl(entityId, layoutVariant)).then((res) => preferencesFromJSON(res != null ? res : {}));
const useUserLayoutPreferences = (entityId, layoutVariant) => {
  const {
    data,
    isLoading: isInitialLoading,
    refetch
  } = useQuery({
    queryKey: ["table-layout", entityId, layoutVariant],
    queryFn: () => defaultOnError(
      fetchUserLayoutPreferences(entityId, layoutVariant),
      `Loading layout preferences for "${entityId}" overview failed with`
    ),
    placeholderData: keepPreviousData,
    // 1 hour
    staleTime: 60 * (60 * 1e3)
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isInitialLoading,
    refetch
  };
};
export default useUserLayoutPreferences;
